import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../assets/css/main.css";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import qrcode from "../assets/img/QRCode.png";

const Payments = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    const [paymentMode, setPaymentMode] = useState("Bank");

    const [paymentData, setPaymentData] = useState({
        name: "",
        transactionId: "",
        email: "",
        contact: "",
        plan: "",
        amount: "",
    });


    const [status, setStatus] = useState({ loading: false, success: false, error: false });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ loading: true, success: false, error: false });

        try {
            const response = await fetch(
                "https://script.google.com/macros/s/AKfycbwANI8D-KhigWDq6N814BeT775HAmlhmslQuNfLBKnCLrNteE4RHG03aK9Yf1Gn3w25/exec",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: `Name=${paymentData.name}&TransactionID=${paymentData.transactionId}&Email=${paymentData.email}&Contact=${paymentData.contact}&Plan=${paymentData.query}&Amount=${paymentData.amount}`,
                }
            ).then((res) => res.text())
                .then((data) => {
                    let timerInterval;
                    Swal.fire({
                        title: `Message Sent Successfully!`,
                        icon: 'success',
                        html: "Autoclose in <b></b> milliseconds.",
                        timer: 3000,
                        timerProgressBar: true,
                        didOpen: () => {
                            Swal.showLoading();
                            const timer = Swal.getPopup().querySelector("b");
                            timerInterval = setInterval(() => {
                                timer.textContent = `${Swal.getTimerLeft()}`;
                            }, 100);
                        },
                        willClose: () => {
                            clearInterval(timerInterval);
                        }

                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.timer) {
                            console.log("");
                        }
                    });
                    setStatus({ loading: false, success: true, error: false });
                    setPaymentData({
                        name: "",
                        transactionId: "",
                        email: "",
                        contact: "",
                        plan: "",
                        amount: "",
                    });
                })
                .catch((error) => {
                    console.error("Error:", error);
                    Swal.fire({
                        icon: "error",
                        title: "Oops!",
                        text: "Something went wrong. Please try again later.",
                        footer: '<a href="mailto:support@example.com">Need help? Contact support</a>',
                    });
                    setStatus({ loading: false, success: false, error: true });
                });
        } catch (error) {
            console.error("Submission error:", error);
            Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "Something went wrong. Please try again later.",
                footer: '<a href="mailto:support@example.com">Need help? Contact support</a>',
            });
            setStatus({ loading: false, success: false, error: true });
        }
    };

    return (
        <section id="payment" className="payment section">
            <div className="container section-title" data-aos="fade-up">
                <h2>Payments</h2>
                <p>Complete your payment and provide the details to proceed with your enrollment.</p>
            </div>

            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row g-4 g-lg-5">
                    {/* Left Section */}
                    <div className="col-lg-6">
                        <div className="payment-info-box h-100 d-flex flex-column">
                            {/* Toggle Buttons */}
                            <div className="btn-group mb-4" role="group" aria-label="Payment Mode">
                                <button
                                    type="button"
                                    className={`btn ${paymentMode === "Bank" ? "activepayments-btn" : "unactivepayments-btn"}`}
                                    onClick={() => setPaymentMode("Bank")}
                                >
                                    Bank Payment
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${paymentMode === "UPI" ? "activepayments-btn" : "unactivepayments-btn"}`}
                                    onClick={() => setPaymentMode("UPI")}
                                >
                                    UPI Payment
                                </button>
                            </div>

                            {/* Display Content Based on Payment Mode */}
                            {paymentMode === "Bank" ? (
                                <div className="bank-details rounded-3 p-4 light-background">
                                    <h3 className="mb-3 text-primary">Bank Account Details</h3>
                                    <p className="text-muted">Use the information below to make your payment:</p>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">
                                            <strong>Account Holder:</strong> Krishna Kumar
                                        </li>
                                        <li className="mb-2">
                                            <strong>Bank Name:</strong> ICICI Bank
                                        </li>
                                        <li className="mb-2">
                                            <strong>Account Number:</strong> 318201502874
                                        </li>
                                        <li className="mb-2">
                                            <strong>IFSC Code:</strong> ICIC0003182
                                        </li>
                                        <li className="mb-2">
                                            <strong>Branch:</strong> HSR Layout, Bangalore
                                        </li>
                                    </ul>
                                </div>
                            ) : (
                                <div className="upi-details text-center">
                                    {/* <h3>Scan QR Code for UPI Payment</h3> */}
                                    <img
                                        src={qrcode}
                                        alt="UPI QR Code"
                                        className="img-fluid mx-auto"
                                        width={400}
                                        height={400}
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="col-lg-6">
                        <div className="payment-form-box">
                            <h3>Submit Payment Details</h3>
                            <p>Fill in the form below after completing your payment.</p>

                            <form onSubmit={handleSubmit} className="php-email-form">
                                <div className="row gy-4">
                                    <div className="col-12">
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            placeholder="Your Name"
                                            value={paymentData.name}
                                            onChange={(e) => setPaymentData({ ...paymentData, name: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div className="col-12">
                                        <input
                                            type="text"
                                            name="transactionId"
                                            className="form-control"
                                            placeholder="Transaction ID"
                                            value={paymentData.transactionId}
                                            onChange={(e) => setPaymentData({ ...paymentData, transactionId: e.target.value })}
                                            required
                                        />
                                    </div>

                                    
                                    <div className="col-12">
                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control"
                                            placeholder="Email ID"
                                            value={paymentData.email}
                                            onChange={(e) => setPaymentData({ ...paymentData, email: e.target.value })}
                                            required
                                        />
                                    </div>

                                    
                                    <div className="col-12">
                                        <input
                                            type="text"
                                            name="contact"
                                            className="form-control"
                                            placeholder="Contact Number"
                                            value={paymentData.contact}
                                            onChange={(e) => setPaymentData({ ...paymentData, contact: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div className="col-12">
                                        <input
                                            type="text"
                                            name="plan"
                                            className="form-control"
                                            placeholder="Payment For (Plan Name)"
                                            value={paymentData.plan}
                                            onChange={(e) => setPaymentData({ ...paymentData, plan: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div className="col-12">
                                        <input
                                            type="number"
                                            name="amount"
                                            className="form-control"
                                            placeholder="Amount Paid"
                                            value={paymentData.amount}
                                            onChange={(e) => setPaymentData({ ...paymentData, amount: e.target.value })}
                                            required
                                        />
                                    </div>


                                    <div className="col-12 text-center">
                                        {status.loading && <div className="loading">Loading...</div>}
                                        {status.error && <div className="error-message">Something went wrong. Please try again.</div>}
                                        {status.success && <div className="sent-message">Your message has been sent. Thank you!</div>}

                                        <button type="submit" className="il-btn" disabled={status.loading}>
                                            {status.loading ? (
                                                <span className="spinner"></span>
                                            ) : (
                                                "Submit"
                                            )}
                                        </button>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Payments;
